import ComponentsFactory from 'foundation/components-factory';
import BroadcastersComponent from './js/broadcasters.component';
import './scss/index.scss';

ComponentsFactory.getInstance().define('broadcasters', BroadcastersComponent);
